import React, { useEffect, useState } from 'react';
import Benifits from '../../components/forOwners/benifitis';
import Intro from '../../components/forOwners/intro';
import Participate from '../../components/forOwners/participate';
import Hero_9 from '../../components/forOwners/hero_9';
import Meta from '../../components/Meta';
import Process from '../../components/forOwners/process';
import InteractiveFeatures from '../../components/forOwners/interactive_features';

const Home_9 = () => {
  // useEffect(() => {
  //   const header = document.querySelector('header');
  //   header.classList.add('bg-white/[.15]');
  // }, []);

  return (
    <>
      <Meta title='For Collection Owners' />
      <Hero_9 />
      {/* <Partners /> */}
      <Intro />
      <Benifits />
      <InteractiveFeatures />
      <Participate />
      <Process />
      {/* <TrustedPartner /> */}
      {/* <NewseLatter2 bgWhite={false} /> */}
    </>
  );
};

export default Home_9;
